$(document).ready(function () {

    $('#product-carousel-main .carousel-inner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite:false
    });

    $('#slick-carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('.products-prev'),
        nextArrow: $('.products-next'),
        dots: false
    });
    

    $(window).resize(function () {
        var bodyheight = $('#product-carousel-main .carousel-inner').width();
        var paddingTop = bodyheight / 2 - $('.carousel-img').height() / 2;
        $("#product-carousel-main .carousel-inner").height(bodyheight);
        $("#product-carousel-main .carousel-inner .carousel-img").css('margin-top', paddingTop);
    }).resize();

    

    function getAttributesList() {
        var attributes = [];

        $('.attribute-selector').each(function () {
            attributes.push($(this).val());
        });

        return attributes;
    }

    $('.serie-input').click(function () {
        var optionId = $(this).data('id');
        var price = $(this).find('span').data('price');
        var discount = $(this).find('span').data('discount');

        if (discount === "0,00" || discount === "0.00") {
            $("#currentPrice").html(price + " $");           
        }
        else {
            $("#currentPrice").html("<span class='discount d-block'>" + price + " $</span>" + discount + " $");
        }

        $('#priceOptionId').val(optionId);
    });

    $('.add-basket').click(function () {
        var productid = $(this).data("id");

        $.ajax({
            type: "POST",
            url: '/basket/Add',
            data: {
                ProductId: productid,
                PriceOptionId: $('#priceOptionId-' + productid).val(),
                Quantity: $('#Quantity-' + productid).val(),
                SelectedAttributes: getAttributesList()
            },
            success: function (data) {
                $('.basketItemCount').html(data);
                $('#result').toggleClass('d-none').toggleClass('show');
                setTimeout(function () {
                    $('#result-' + productid).toggleClass('d-none').toggleClass('show');
                }, 1000);
            }
        });
    });
});